import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid, Box, Checkbox, Link } from '@material-ui/core';
import T from 'i18n-react';
import { getLocale, paymentTerms, scrollToTop, tradeTerms } from 'util/icwUtility';
import Select from 'react-select';
import { TextField } from 'icw-components/InputFields';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import UploadFiles from './components/UploadFiles';

const ProductDetails = ({
  formik,
  productCategories,
  productSpecFiles,
  productPhotos,
  productDocuments,
  setProductSpecFiles,
  setProductPhotos,
  setProductDocuments,
  handleSelectChange,
}) => {
  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <>
      <Box py={2}>
        <Grid container spacing={2} justify='center' alignItems='center'>
          <Grid item xs={12} sm={12} md={12}>
            <Box
              fontSize='16px'
              fontWeight='bold'
              color='#1D293F'
              diplay='flex'
              justifyContent='center'
              py={1}>
              {T.translate('iSource.supplierForm.productType.title')}
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={6}>
            <Box fontSize='12px' fontWeight='400'>
              {T.translate('iSource.form.productName')}*
            </Box>
            <TextField
              name='productName'
              variant='outlined'
              fullWidth
              noLabel
              placeholder={T.translate('iSource.placeholder.productName')}
              value={formik.values.productName}
              error={!!(formik.touched.productName && formik.errors.productName)}
              setFieldTouched={formik.setFieldTouched}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <Box fontSize='12px' fontWeight='500' color='red'>
              {formik.touched.productName && formik.errors.productName}
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={6}>
            <Box fontSize='12px' fontWeight='400'>
              {T.translate('iSource.supplierForm.productType.productCategory')}
            </Box>
            <Select
              name='productProductCategories'
              styles={{
                control: (base) => ({
                  ...base,
                  marginTop: '8px',
                  marginBottom: '4px',
                  padding: '1px 0',
                  backgroundColor: 'transparent',
                  '&:hover': {
                    borderColor: '#000',
                  },
                  borderColor:
                    formik.touched.productProductCategories &&
                    formik.errors.productProductCategories
                      ? '#f44336'
                      : 'rgba(0, 0, 0, 0.23)',
                }),
              }}
              options={productCategories.map((pc) => ({
                value: pc.id,
                label: pc[`name_${getLocale().replace('-', '')}`],
              }))}
              value={formik.productProductCategories}
              onChange={(values) => handleSelectChange(values, 'productProductCategories')}
              onBlur={() => formik.setFieldTouched('productProductCategories', true, true)}
              isMulti
              placeholder={T.translate('iSource.placeholder.options')}
            />
            <Box fontSize='12px' fontWeight='500' color='red'>
              {formik.touched.productProductCategories && formik.errors.productProductCategories}
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Box fontSize='12px' fontWeight='400'>
              {T.translate('iSource.supplierForm.productDetails.productDescription')}*
            </Box>
            <TextField
              name='productDescription'
              variant='outlined'
              fullWidth
              noLabel
              placeholder={T.translate('iSource.placeholder.productDescription')}
              value={formik.values.productDescription}
              error={!!(formik.touched.productDescription && formik.errors.productDescription)}
              setFieldTouched={formik.setFieldTouched}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              multiline
              rows={5}
              rowsMax={10}
            />
            <Box fontSize='12px' fontWeight='500' color='red'>
              {formik.touched.productDescription && formik.errors.productDescription}
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={6}>
            <Box fontSize='12px' fontWeight='400'>
              {T.translate('iSource.supplierForm.productDetails.preferredPrice')}
            </Box>
            <TextField
              name='unitPrice'
              variant='outlined'
              fullWidth
              noLabel
              placeholder='$'
              value={formik.values.unitPrice}
              error={!!(formik.touched.unitPrice && formik.errors.unitPrice)}
              setFieldTouched={formik.setFieldTouched}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <Box fontSize='12px' fontWeight='500' color='red'>
              {formik.touched.unitPrice && formik.errors.unitPrice}
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={6}>
            <Box fontSize='12px' fontWeight='400'>
              {T.translate('iSource.supplierForm.productDetails.MOQ')}
            </Box>
            <TextField
              name='MOQ'
              variant='outlined'
              fullWidth
              noLabel
              placeholder={T.translate('iSource.supplierForm.productDetails.placeholder.MOQ')}
              value={formik.values.MOQ}
              error={!!(formik.touched.MOQ && formik.errors.MOQ)}
              setFieldTouched={formik.setFieldTouched}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <Box fontSize='12px' fontWeight='500' color='red'>
              {formik.touched.MOQ && formik.errors.MOQ}
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={2} justify='center' alignItems='center'>
          <Grid item xs={12} sm={12} md={12}>
            <Box fontSize='12px' fontWeight='400'>
              {T.translate('iSource.supplierForm.productDetails.productSpecification')}
            </Box>
            <TextField
              name='productSpecification'
              variant='outlined'
              fullWidth
              noLabel
              placeholder={T.translate('iSource.placeholder.productSpecification')}
              value={formik.values.productSpecification}
              error={!!(formik.touched.productSpecification && formik.errors.productSpecification)}
              setFieldTouched={formik.setFieldTouched}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              multiline
              rows={5}
              rowsMax={10}
            />
            <Box fontSize='12px' fontWeight='500' color='red'>
              {formik.touched.productSpecification && formik.errors.productSpecification}
            </Box>
          </Grid>
        </Grid>
      </Box>
      <UploadFiles
        title={T.translate('iSource.supplierForm.productDetails.uploadProductSpecifications')}
        files={productSpecFiles}
        setFiles={setProductSpecFiles}
      />
      <UploadFiles
        title={T.translate('iSource.supplierForm.productDetails.uploadProductPhotos')}
        files={productPhotos}
        setFiles={setProductPhotos}
      />
      <UploadFiles
        title={T.translate('iSource.supplierForm.productDetails.uploadProductDocuments')}
        files={productDocuments}
        setFiles={setProductDocuments}
      />
      <Box py={2}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={6}>
            <Box fontSize='12px' fontWeight='400'>
              {T.translate('iSource.supplierForm.productDetails.paymentTerm')}
            </Box>
            <Select
              name='paymentTerm'
              styles={{
                control: (base) => ({
                  ...base,
                  backgroundColor: 'transparent',
                  '&:hover': {
                    borderColor: '#0C91C4',
                  },
                }),
              }}
              options={paymentTerms}
              value={formik.paymentTerm}
              onChange={(values) => handleSelectChange(values, 'paymentTerm')}
              onBlur={formik.handleBlur}
              placeholder={T.translate('iSource.placeholder.options')}
            />
            <Box fontSize='12px' fontWeight='500' color='red'>
              {formik.touched.paymentTerm && formik.errors.paymentTerm}
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={6}>
            <Box fontSize='12px' fontWeight='400'>
              {T.translate('iSource.supplierForm.productDetails.tradeTerm')}
            </Box>
            <Select
              name='tradeTerm'
              styles={{
                control: (base) => ({
                  ...base,
                  backgroundColor: 'transparent',
                  '&:hover': {
                    borderColor: '#0C91C4',
                  },
                }),
              }}
              options={tradeTerms}
              value={formik.tradeTerm}
              onChange={(values) => handleSelectChange(values, 'tradeTerm')}
              onBlur={formik.handleBlur}
              placeholder={T.translate('iSource.placeholder.options')}
            />
            <Box fontSize='12px' fontWeight='500' color='red'>
              {formik.touched.tradeTerm && formik.errors.tradeTerm}
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box color='#232B3A' fontSize='16px' fontWeight='400' mt={3}>
              {T.translate('iSource.supplierForm.productDetails.verificationMsg')}
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={2} justify='center' alignItems='center'>
          <Grid item xs={12}>
            <FormControlLabel
              control={<Checkbox />}
              name='termsAndConds'
              label={
                <Box>
                  {T.translate('iSource.supplierForm.productDetails.ICWService', {
                    termsAndConds: (
                      <Link href='/terms-conditions' target='_blank'>
                        {T.translate('iSource.supplierForm.productDetails.termsAndConds')}
                      </Link>
                    ),
                  })}
                </Box>
              }
              checked={formik.termsAndConds}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <Box fontSize='12px' fontWeight='500' color='red'>
              {formik.touched.termsAndConds && formik.errors.termsAndConds}
            </Box>
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={<Checkbox />}
              name='acceptRefer'
              label={T.translate('iSource.supplierForm.productDetails.acceptRefer')}
              checked={formik.acceptRefer}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <Box fontSize='12px' fontWeight='500' color='red'>
              {formik.touched.acceptRefer && formik.errors.acceptRefer}
            </Box>
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={<Checkbox />}
              name='validInformation'
              label={T.translate('iSource.supplierForm.productDetails.validInformation')}
              checked={formik.validInformation}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <Box fontSize='12px' fontWeight='500' color='red'>
              {formik.touched.validInformation && formik.errors.validInformation}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

ProductDetails.propTypes = {
  formik: PropTypes.object.isRequired,
  productCategories: PropTypes.array.isRequired,
  productSpecFiles: PropTypes.array.isRequired,
  productPhotos: PropTypes.array.isRequired,
  productDocuments: PropTypes.array.isRequired,
  setProductSpecFiles: PropTypes.func.isRequired,
  setProductPhotos: PropTypes.func.isRequired,
  setProductDocuments: PropTypes.func.isRequired,
  handleSelectChange: PropTypes.func.isRequired,
};

export default ProductDetails;
